module.exports = __webpack_public_path__ + "img/ic_shift_detail.37bc54ef.svg";